import { render, staticRenderFns } from "./cell_flags.vue?vue&type=template&id=64925cd5&scoped=true&"
import script from "./cell_flags.vue?vue&type=script&lang=js&"
export * from "./cell_flags.vue?vue&type=script&lang=js&"
import style0 from "./cell_flags.vue?vue&type=style&index=0&id=64925cd5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64925cd5",
  null
  
)

export default component.exports